// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  width: 100%;
  height: 100px;
  background-color: #047da2;
  position: fixed;
  bottom: 0;
}

@media (max-width: 768px) {
  .footer {
    height: 50px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/footer/Footer.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".footer {\n  width: 100%;\n  height: 100px;\n  background-color: #047da2;\n  position: fixed;\n  bottom: 0;\n}\n\n@media (max-width: 768px) {\n  .footer {\n    height: 50px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
